module.exports = __webpack_public_path__ + "theme/assets/img/ccfd7f6bfa9f85b5964f3815a25def05.jpg";